import axiosInstance from '../../config/AxiosConfig';
import {
  BankAccountListResp,
  BankAccountDetailResp,
} from 'domain/payload/response/bankamar/BankAccountResp';

const AmarBankService = () => {
    const getList = async (
    token: string,
    page?: number,
    size?: number,
    search?: string | null,
    status?: 'accepted' | 'rejected' | null,
    rejectReason?: string | null
  ):Promise<BankAccountListResp> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/amar-integration/bank-account-registrations/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            page,
            size,
            search,
            status,
            rejectReason,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const getDetail = async (
    token: string,
    id: string
  ): Promise<BankAccountDetailResp> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/amar-integration/bank-account-registrations/detail`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return { getList, getDetail };
};

export default AmarBankService;
